import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from "ngx-bootstrap/modal";
import { DialogsService } from '../../services/dialogs.service';

@Component({
    selector: 'app-angular-confirm',
    templateUrl: './angular-confirm.component.html',
    styleUrls: ['./angular-confirm.component.scss']
})
export class AngularConfirmComponent {
    Title: string = "";
    Message: string = "";
    cancelButtonText: string = "";
    okButtonText: string = "";

    @ViewChild('confirmModal') public confirmModal: ModalDirective;

    constructor(private dialogService: DialogsService){
        dialogService.confirm = this.show.bind(this);
    }

    private reset() {
        this.Title = "";
        this.Message = "";
        this.cancelButtonText = "Annulla";
        this.okButtonText = "OK";
    }

    public show(Title: string, Message: string, cancelButtonText: string, okButtonText: string):  Promise<boolean>{
        return new Promise<boolean>((resolve) => {
            this.reset();
            this.Title = Title;
            this.Message = Message;
            if(cancelButtonText) this.cancelButtonText = cancelButtonText;
            if(okButtonText) this.okButtonText = okButtonText;
            this.confirmModal.show();
            document.getElementById('confirmCancelButton').onclick = () => {
                this.confirmModal.hide();
                resolve(false);
            }
            document.getElementById('confirmOkButton').onclick = () => {
                this.confirmModal.hide();
                resolve(true);
            }
        })
    }

    onShown() {
        if (!document.body.classList.contains("modal-open")) document.body.classList.add("modal-open");
    }
    
    onHidden(){
        let modals = document.querySelectorAll(".modal-backdrop");
        if (modals.length == 0) document.body.classList.remove("modal-open");
    }
}